import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import WhatsAppButton from "@/components/feature/WhatsAppButton";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

export default function PageWrapper({ children, className = "" }: { children: React.ReactNode; className?: string }) {
  const location = useLocation();

  return (
    <div className={`relative min-h-screen bg-white overflow-x-hidden ${className}`}>
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <motion.div
          className="absolute -top-24 left-[-6rem] h-72 w-72 rounded-full bg-brand/10 blur-3xl"
          animate={{ x: [0, 45, 0], y: [0, 30, 0] }}
          transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
          className="absolute top-1/3 right-[-7rem] h-80 w-80 rounded-full bg-amber-300/20 blur-3xl"
          animate={{ x: [0, -40, 0], y: [0, -24, 0] }}
          transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
          className="absolute bottom-[-7rem] left-1/3 h-72 w-72 rounded-full bg-stone-300/30 blur-3xl"
          animate={{ x: [0, 22, 0], y: [0, -35, 0] }}
          transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>
      <Navbar />
      <main className="relative z-10 overflow-x-hidden">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
        >
          {children}
        </motion.div>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}